module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 48
// module chunks = 3 4